import { Route, Switch } from 'react-router-dom';
import styled from 'styled-components';

import React, { PureComponent } from 'react';
import { Col, Row, FlexView, Text, Separator } from '@cuemath/comps';

import Program from 'screens/curriculum/program';
import Chapter from 'screens/curriculum/chapter';
import ChapterContent from 'screens/curriculum/chapter-content';
import BlockContent from 'screens/curriculum/block-content';
import Logout from 'modules/logout';

const FullWindowHeightRow = styled(Row)`
  height: 100vh;
  overflow-x: auto;
`;
const ShadowedCol = styled(Col)`
  box-shadow: 2px 0 2px rgba(204, 204, 204, 0.5);
  padding: 0;
  overflow-y: auto;
`;
const ProgramsCol = styled(ShadowedCol)`
  min-width: 200px;
`;
const ChaptersCol = styled(ShadowedCol)`
  min-width: 350px;
`;
const BlockCol = styled(ShadowedCol)`
  min-width: 350px;
`;
const WorksheetCol = styled(ShadowedCol)`
  min-width: 350px;
`;

export default class Curriculum extends PureComponent {
  render() {
    return (
      <FlexView>
        <Row alignItems="center">
          <Col auto>
            <Text align="center" weight="bold">
              Curriculum Admin
            </Text>
          </Col>
          <Col autoRight>
            <Logout />
          </Col>
        </Row>
        <Separator />
        <FullWindowHeightRow>
          <ProgramsCol>
            <Switch>
              <Route path="/curriculum/:programCode" component={Program} />
              <Route path="/curriculum/" component={Program} />
            </Switch>
          </ProgramsCol>
          <ChaptersCol>
            <Switch>
              <Route
                path="/curriculum/:programCode/chapter-contents/:versionId/"
                component={Chapter}
              />
              <Route path="/curriculum/:programCode/" component={Chapter} />
            </Switch>
          </ChaptersCol>
          <BlockCol>
            <Switch>
              <Route
                path="/curriculum/:programCode/chapter-contents/:versionId/block-contents/:blockVersionId/"
                component={ChapterContent}
              />
              <Route
                path="/curriculum/:programCode/chapter-contents/:versionId/"
                component={ChapterContent}
              />
            </Switch>
          </BlockCol>
          <WorksheetCol>
            <Route
              path="/curriculum/:programCode/chapter-contents/:versionId/block-contents/:blockVersionId/"
              component={BlockContent}
            />
          </WorksheetCol>
        </FullWindowHeightRow>
      </FlexView>
    );
  }
}
